export function getWWidth() {
  let width = window.outerWidth;
  width = document.body["offsetWidth"];
  return width;
}
